import TagManager from 'react-gtm-module';

// Initialize GTM with your container ID and optionally custom dataLayer variables
export const initGTM = () => {
  TagManager.initialize({
    gtmId: process.env.REACT_APP_X_GTM_CONTAINER_ID || '',
  });
};
